// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Global "Scheduled Maintenance" banner.
  // enabled: master on/off switch.
  // from/to: date & time in JAPAN STANDARD TIME (JST), format 'YYYY-MM-DD HH:mm'.
  // The banner shows only while enabled AND the current time is within [from, to).
  maintenance: {
    enabled: false,
    from: '2026-06-23 04:00',
    to: '2026-06-24 02:00'
  },
  firebase: {
    apiKey: "AIzaSyDIRn7Lq4Xf7hX9-9LsgC94Vqr8V7QYf0M",
    authDomain: "mtc-filetransfer.firebaseapp.com",
    databaseURL: "https://mtc-filetransfer.firebaseapp.com",
    projectId: "mtc-filetransfer",
    storageBucket: "mtc-filetransfer.appspot.com",
    // storageBucket: "mtc-filetransfer.appspot.com",
    messagingSenderId: "184320802582"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
